// extracted by mini-css-extract-plugin
module.exports = {"playerCard":"style_playerCard__2KIjI","playerCard_line":"style_playerCard_line__3M55M"};